import { render, staticRenderFns } from "./SearchResultDelivering.vue?vue&type=template&id=84e4c3f4&scoped=true"
import script from "./SearchResultDelivering.vue?vue&type=script&lang=js"
export * from "./SearchResultDelivering.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e4c3f4",
  null
  
)

export default component.exports